module.exports = __webpack_public_path__ + "static/media/ilkley-28.02ff9b2e.jpg";